<mat-card-content
  class="flex flex-row entry-table h-full"
>
  <div class="sustainability-grid-wrapper">
    <div class="sustainability-distance-note">
      Enter only the one way distance between home and office
    </div>
    <ag-grid-angular
      style="max-width: 2256px; width: 100%; "
      class="ag-theme-balham w-full"
      [rowData]="gridRowData"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      rowSelection="multiple"
      [suppressRowClickSelection]="true"
      [animateRows]="true"
      style="width: 100%; height: 500px;"
      (rowDoubleClicked)="onRowDoubleClicked($event)"
      (selectionChanged)="onSelectionChanged($event)"
      (rowClicked)="onRowClicked($event)"
      (cellClicked)="onCellClicked($event)"
      (cellFocused)="onCellFocused($event)"
    >
    </ag-grid-angular>
  </div>
</mat-card-content>